//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { mapGetters } from 'vuex';

export default {
	name: 'MallTabsDisplay',

	props: {
		// 데이터 소스
		tabs: {
			type: Array,
			default: null,
		},
		// Vuex getter 이름 (tabs가 없을 때 사용)
		storeGetter: {
			type: String,
			default: 'mall/isMainTabs',
		},

		// 레이아웃 설정
		containerClass: {
			type: String,
			default: 'py-2',
		},
		contentPadding: {
			type: String,
			default: 'pa-0 py-3',
		},

		// 그리드 설정
		gridConfig: {
			type: Object,
			default: () => ({
				dense: false,
				cols: 6,
				sm: 4,
				md: 3,
				lg: 3,
				xl: 2,
			}),
		},

		// 탭 설정
		tabsConfig: {
			type: Object,
			default: () => ({
				backgroundColor: 'transparent',
				color: '#2196f3',
				dark: false,
				showArrows: true,
				centerActive: false,
				grow: false,
				badgeColor: 'primary',
			}),
		},

		// 카드 설정
		cardConfig: {
			type: Object,
			default: () => ({
				backgroundColor: 'transparent',
				imageHeight: 150,
				aspectRatio: 1,
				imageContain: true,
				imageClass: 'white',
				titleClass: 'justify-center text-subtitle-1',
				subtitleClass: 'text-center text-caption',
				hover: true,
				elevation: 1,
			}),
		},

		// 빈 상태 설정
		emptyConfig: {
			type: Object,
			default: () => ({
				message: '등록된 항목이 없습니다.',
				icon: 'mdi-inbox-outline',
				iconSize: 64,
				iconColor: 'grey lighten-1',
				textColor: 'grey',
				backgroundColor: 'transparent',
				class: 'text-center py-6',
			}),
		},

		// 기능 토글
		showItemCount: {
			type: Boolean,
			default: false,
		},
		showActions: {
			type: Boolean,
			default: false,
		},
		enableRouting: {
			type: Boolean,
			default: false,
		},

		// 가격 포맷
		priceFormat: {
			type: Object,
			default: () => ({
				currency: '₩',
				decimals: 0,
				thousandsSeparator: ',',
			}),
		},
	},

	data() {
		return {
			tab: null,
			baseUrl: `${process.env.baseURL}api/admin/malls/displayFile?fileName=`,
		};
	},

	computed: {
		// 탭 데이터 소스 (props 우선, 없으면 Vuex)
		computedTabs() {
			if (this.tabs) {
				return this.tabs;
			}
			const [namespace, getter] = this.storeGetter.split('/');
			if (namespace && getter) {
				return this.$store.getters[this.storeGetter] || [];
			}
			return [];
		},

		// 카드 컴포넌트 결정
		cardComponent() {
			return this.enableRouting ? 'router-link' : 'v-card';
		},
	},

	methods: {
		// 카드 props 생성
		getCardProps(item) {
			const baseProps = {
				hover: this.cardConfig.hover,
				elevation: this.cardConfig.elevation,
			};

			if (this.enableRouting && item.route) {
				return {
					...baseProps,
					to: item.route,
					tag: 'div',
					class: 'v-card text-decoration-none',
				};
			}

			const linkUrl = this.getLinkUrl(item);
			if (linkUrl) {
				return {
					...baseProps,
					href: linkUrl,
					target: '_blank',
				};
			}

			return baseProps;
		},

		// 링크 URL 생성
		getLinkUrl(item) {
			if (item.linkType === 'URL' && item.linkInfo) {
				return item.linkInfo.startsWith('http') ? item.linkInfo : `http://${item.linkInfo}`;
			}
			return null;
		},

		// 아이템 클릭 핸들러
		handleItemClick(item) {
			this.$emit('item-click', item);
		},

		// 가격 포맷팅
		formatPrice(price) {
			if (!price && price !== 0) return '';

			const { currency, decimals, thousandsSeparator } = this.priceFormat;
			const formatted = price
				.toFixed(decimals)
				.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);

			return `${currency}${formatted}`;
		},
	},
};
